import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DetalhesLotesRoutingModule } from './detalhes-lotes-routing.module';
import { DetalhesLotesListComponent } from './detalhes-lotes-list/detalhes-lotes-list.component';
import { DetalhesLotesComponent } from './detalhes-lotes.component';
import { SharedModule } from '../../shared/shared.module';
import { CampoNfComponent } from './campo-nf/campo-nf.component';
import { CampoRpaComponent } from './campo-rpa/campo-rpa.component';

@NgModule({
  declarations: [
    DetalhesLotesComponent,
    DetalhesLotesListComponent,
    CampoNfComponent,
    CampoRpaComponent
  ],
  imports: [CommonModule, DetalhesLotesRoutingModule, SharedModule],
  exports: [DetalhesLotesComponent, DetalhesLotesListComponent]
})
export class DetalhesLotesModule {}
